import React from 'react'
import { components } from 'cng-web-lib'

import FormProperties from './CiaFtaMapping_FormProperties'
import CalistaAdvisoryFtaMappingApiUrls from 'src/apiUrls/cia-admin/CalistaAdvisoryFtaMappingApiUrls'
import CiaPathMap from 'src/paths/PathMap_CalistaAdvisory'

const { form: { CngAddForm } } = components

function AddPage({ history, showNotification }) {

    //* return JSX -------------------------------------------------------------
    return (

        //* Start JSX ----------------------------------------------------------
        <CngAddForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            history={history}
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    isEditable={false}
                    showNotification={showNotification}
                />
            }
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            create={{
                url: CalistaAdvisoryFtaMappingApiUrls.POST,
                successRedirect: CiaPathMap.CALISTA_ADVISORY_ADMIN_FTA_MAPPING_LIST_VIEW
            }}
        />
        //* End JSX ------------------------------------------------------------

    );

    //* End of function --------------------------------------------------------
}

export default AddPage